import { TaskCriticalityEnum } from 'src/graphql/schema';

export const timeRangeOptions = [
  { label: 'Today', value: 'today' },
  { label: 'Last 2 days', value: 'last_2_days' },
  { label: 'Last 7 days', value: 'last_7_days' },
  { label: 'Last 30 days', value: 'last_30_days' },
] as const;

export const criticalityOptions = [
  { label: 'High criticality', value: TaskCriticalityEnum.High },
  { label: 'Medium criticality', value: TaskCriticalityEnum.Medium },
  { label: 'Low criticality', value: TaskCriticalityEnum.Low },
] as const;

export const eventTypeKeys = [
  'escrow_invitation_sent',
  'escrow_invitation_rejected',
  'agreement_sent_for_review_beneficiary',
  'agreement_sent_for_review_depositor',
  'agreement_resent_for_review_depositor',
  'agreement_resent_for_review_beneficiary',
  'signatures_requested',
  'escrow_signed',
  'suggested_change_created',
  'escrow_termination_requested',
  'escrow_terminated',
  'custodian_profile_terminated',
  'escrow_pending_activation',
  'asset_disconnected',
  'continuity_provider_removed',
  'continuity_provider_access_issues',
  'payment_source_expiring',
  'payment_source_expired',
  'app_created',
  'app_request_created',
] as const;

export const eventTypeOptions = {
  organization: {
    label: 'Organization',
    separator: true,
    options: [
      {
        label: 'Billing',
        value: 'billing',
      },
    ],
  },
  applications: {
    label: 'Applications',
    separator: true,
    options: [
      {
        label: 'Applications',
        value: 'applications',
      },
    ],
  },
  escrows: {
    label: 'Escrows',
    separator: true,
    options: [
      {
        label: 'All Escrow',
        value: 'all-escrows',
      },
      {
        label: 'Assets (Software & SaaS)',
        value: 'assets',
      },
      {
        label: 'Agreements',
        value: 'agreements',
      },
      {
        label: 'Change requests',
        value: 'change-requests',
      },
      {
        label: 'Invitations',
        value: 'invitations',
      },
      {
        label: 'Providers (Continuity)',
        value: 'providers',
      },
      {
        label: 'Terminations',
        value: 'terminations',
      },
    ],
  },
  custodian: {
    label: 'Custodian',
    separator: false,
    options: [
      {
        label: 'Access',
        value: 'access',
      },
    ],
  },
};

export const eventTypesByFilterValue = {
  billing: ['payment_source_expiring', 'payment_source_expired'],
  applications: ['app_created', 'app_request_created'],
  'all-escrows': [
    'escrow_invitation_sent',
    'escrow_invitation_rejected',
    'agreement_sent_for_review_depositor',
    'agreement_sent_for_review_beneficiary',
    'agreement_resent_for_review_depositor',
    'agreement_resent_for_review_beneficiary',
    'suggested_change_created',
    'escrow_termination_requested',
    'escrow_signed',
    'asset_disconnected',
    'escrow_pending_activation',
    'continuity_provider_removed',
    'continuity_provider_access_issues',
    'escrow_terminated',
  ],
  assets: ['asset_disconnected'],
  agreements: [
    'agreement_sent_for_review_depositor',
    'agreement_sent_for_review_beneficiary',
    'agreement_resent_for_review_depositor',
    'agreement_resent_for_review_beneficiary',
    'escrow_signed',
  ],
  'change-requests': ['suggested_change_created'],
  invitations: ['escrow_invitation_sent', 'escrow_invitation_rejected'],
  providers: ['escrow_pending_activation', 'continuity_provider_removed', 'continuity_provider_access_issues'],
  terminations: ['escrow_termination_requested', 'escrow_terminated'],
  access: ['custodian_profile_terminated'],
};
